// Highcharts renders tooltip HTML outside Vue's own sanitized template compiler (contract 02's
// global `useHTML: true` default, `highchartsSetup.ts`), so every chart tooltip that builds
// markup from caller-supplied text (a metric label, a series name) must escape it here first.

const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

export function escapeTooltipText(value: unknown): string {
  return String(value).replace(/[&<>"']/gu, (char) => ESCAPE_MAP[char] ?? char)
}

/**
 * A small stacked tooltip card: a muted uppercase caption (e.g. a date), then a label and a bold
 * value. `valueColor` lets the value line pick up the same accent color as the point it
 * describes. Every interpolated value is escaped via {@link escapeTooltipText}.
 */
export function buildStackedChartTooltip(
  caption: string,
  label: string,
  value: string,
  valueColor?: string,
): string {
  const colorStyle = valueColor ? ` style="color:${escapeTooltipText(valueColor)}"` : ''
  return (
    '<div class="ui-chart-tooltip-stack grid min-w-[8.75rem] gap-0.5 p-2.5 font-sans">' +
    `<div class="ui-chart-tooltip-stack__caption mb-2xs text-2xs font-medium uppercase text-subtle">${escapeTooltipText(caption)}</div>` +
    `<div class="ui-chart-tooltip-stack__label text-[0.6875rem] font-semibold text-muted">${escapeTooltipText(label)}</div>` +
    `<div class="ui-chart-tooltip-stack__value font-numeric text-sm font-bold text-fg"${colorStyle}>${escapeTooltipText(value)}</div>` +
    '</div>'
  )
}
